import { generatePath } from 'react-router-dom'
import {
  PRODUCT_GROUPS,
  PRODUCT_GROUPS_UPDATE,
  PRODUCT_GROUPS_CREATE,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestProductGroups = async () => {
  const response = await request.get(PRODUCT_GROUPS)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}

export const requestProductGroupsUpdate = async (id, params) => {
  const path = generatePath(PRODUCT_GROUPS_UPDATE, { id })
  const response = await request.patch(path, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}

export const requestProductGroupsCreate = async (params) => {
  const response = await request.post(PRODUCT_GROUPS_CREATE, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))

  return response
}
